/* src/app/loading-spinner/loading-spinner/loading-spinner.component.scss */
.text-loader {
  top: 44%;
  left: calc(50% - 30px);
  position: fixed;
}
/*# sourceMappingURL=loading-spinner.component.css.map */
